import { render, staticRenderFns } from "./GlobalPeriodRange.vue?vue&type=template&id=c5d7bf0c&"
import script from "./GlobalPeriodRange.vue?vue&type=script&lang=js&"
export * from "./GlobalPeriodRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports